import cx from 'classnames'
import { useRef } from 'react'

import Styles from './Dropzone.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useFileUpload } from '../BrandProfileWebsite/UploadModal/useFileUpload'
import { Button } from 'blaze-ui/Button'
import { Upload5 } from 'blaze-ui/icons'
import { useDropzone } from 'react-dropzone'
import { MediaObject } from 'types'
import { BRAND_PROFILE_SUPPORTED_FILE_TYPES } from 'components/FirstTimeExperienceModal/steps/BrandProfileDocuments/BrandProfileDocuments'
import { Text } from 'blaze-ui/Text/Text'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

const DragOverlay = ({ isActive }: { isActive: boolean }) => (
  <div className={cx(Styles.dragOverlay, { [Styles.dragActive]: isActive })}>
    <Heading level={5} color="var(--light-100)">
      Drop your files here
    </Heading>
  </div>
)

export const Dropzone = ({ onUpload }: { onUpload: (mediaObjects: MediaObject[]) => void }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { handleUpload, isLoading } = useFileUpload()
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: async (files) => {
      const dismiss = showToastMessage('Uploading...', 'loading', undefined, 0)
      const mediaObjects = await handleUpload(files)

      if (mediaObjects) {
        onUpload(mediaObjects)
      }

      dismiss?.()
    },
    accept: BRAND_PROFILE_SUPPORTED_FILE_TYPES,
  })

  return (
    <div {...getRootProps()} className={cx(Styles.dropzone)} data-testid="upload-dropzone">
      <input {...getInputProps()} ref={inputRef} aria-label="Upload files" />
      <DragOverlay isActive={isDragActive} />
      {!isDragActive && (
        <>
          <div className={Styles.imgContent}>
            <img
              src="https://res.cloudinary.com/almanac/image/upload/v1765809079/blaze_assets/virtual_marketer/onboarding/brand_documents_djwk9w.png"
              alt="Dropzone"
              className={Styles.dropzoneImage}
            />
            <Text variant="secondary" color="var(--dark-40)">
              Examples include: <br /> Homepage, services/product pages and any other pages
            </Text>
          </div>
          <div className={Styles.buttonContainer}>
            <Button
              variant="secondary"
              size="xl"
              frontIcon={Upload5}
              isDisabled={isLoading}
              onPress={() => inputRef.current?.click()}
            >
              Upload Screenshots
            </Button>
            <Text variant="secondary" color="var(--dark-40)">
              Supported formats: PNG and JPG
            </Text>
          </div>
        </>
      )}
    </div>
  )
}
